import { render, staticRenderFns } from "./return-delivery-sumitomo.vue?vue&type=template&id=651a3c44&"
import script from "./return-delivery-sumitomo.vue?vue&type=script&lang=js&"
export * from "./return-delivery-sumitomo.vue?vue&type=script&lang=js&"
import style0 from "./return-delivery-sumitomo.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports